import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate';
import { useAdminContext } from '../../../context/adminContext';
import { addOrUpdateAboutUsApi, addOrUpdateJobApi, changePartnerEarningWithdrawRequestStatusApi, cityByCountryApi, countryListApi, getAboutUsApi, getJobCategoryApi, getJobListApi, partnerEarningWithdrawRequestApi } from '../../../utils/ApiEndpointFunctions';
import { capitalizeWords, dateFormat } from '../../../utils/HelperFuncitons';
import LimitPagination from '../../common/LimitPagination';
import CommonTable from '../../common/Table/CommonTable'
import ConfirmationModal from '../../common/ConfirmationModal';
import toast from 'react-hot-toast';
import { useFormik } from 'formik';
import ReactSelect from 'react-select';
import AddOrUpdateJob from './AddOrUpdateJob';
import { jobInitialValue, jobValidationSchema } from '../../common/Validation';
import { S3_URL } from '../../../utils/BaseUrl';
import ImageViewModal from '../../common/Modal/ImageViewModal';
import { useSearchParams } from 'react-router-dom';
import JobCategory from './JobCategory';
import AddOrUpdateAboutUs from './AddOrUpdateAboutUs';





const Jobs = () => {
  const [loader, setLoader] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const [tableData, setTableData] = useState([]);
  const [activeTab, setActiveTab] = useState(searchParams.get("tab"))
  const [selectedPage, setSelectedPage] = useState(1);
  const [totalCount, setTotalCount] = useState(null);
  const [page, setPage] = useState(0);
  const [confirmStatus, setConfirmStatus] = useState({ status: "", id: 0 })
  const { limit, adminDetail } = useAdminContext();
  const addOrUpdateJobModalId = "addOrUpdateJobModal";
  const addOrUpdateAboutUsModalId = "addOrUpdateAboutUsModal";
  const [ submitLoader, setSubmitLoader ] = useState(false);
  const imageViewModalId = "imageViewModalId"
  const [selectedImg, setSelectedImg] = useState("")
  const [countryOptions, setCountryOptions] = useState([])
  const [cityOptions, setCityOptions] = useState([])
  

    

  
  const updateJobHandler = (job) => {
    const payload = {
      ...job, countryId: { label: job.countryName, value: job.countryId}, cityId: { label: job.cityName, value: job.cityId}
    }

    formik.setValues(payload);
  }
  const confirmApproveOrReject = (status, id) => {
    setConfirmStatus({ status, id })
    document.getElementById('confirmModalBtn').click()
  }

  const getAllJobList = async (selectedPage, limit) => {
    try {
      setLoader(true);
     
      const res = await getJobListApi(selectedPage, limit, searchFormik?.values?.countryId?.value, searchFormik?.values?.cityId?.value);
      if (res.status === 200 || res.status === 201) {
        const usersData = res?.data?.data?.jobs;
        const totalLength = res?.data?.data?.totalLength;
        setTotalCount(totalLength);
        setPage(Math.ceil(totalLength / limit));
        setTableData(usersData);
      }
    } catch (error) {
      console.log(error)
    }
    setLoader(false)
  }
  const handlePageClick = (event) => {
    let currentPage = event.selected + 1;
    getAllJobList(currentPage, limit)
    setSelectedPage(currentPage)
  };

  const getWalletAmount = (item) => {
    const role = item?.role?.[0]
    return role === "driver" ? (item?.driverDetails?.length ? item.driverDetails[0].totalEarnings : 0)
      : role === "hire" ? item?.rentalVendor?.totalEarnings
        : role === "restaurant" ? item?.restaurant?.totalEarnings
          : role === "salesAgent" ? item?.salesAgent?.totalEarnings
            : 0
  }

  const headerData = [
    { name: "S.NO", className: "col-1", key: "sNo" },
    // { name: "Logo", className: "col-1", key: "logo" },
    { name: "City / Country", className: "col-1", key: "country_city" },
    { name: "Job Title", className: "col-1", key: "title" },
    { name: "Job Type", className: "col-1", key: "jobType" },
      { name: "Category", className: "col-1", key: "category" },
    { name: "Package", className: "col-1", key: "package" },
    { name: "Experience", className: "col-1", key: "experience" },
    { name: "Education", className: "col-1", key: "education" },
    { name: "Open", className: "col-1", key: "isOpen" },
    { name: "Action", className: "col-1", key: "action" },
  ]
  console.log(tableData);


  const RequestTableData = tableData.map((item, index) => ({
    
    sNo: index + 1,
    // logo: <div className="avatar avatar-xs align-middle me-2">
    //           <img
    //             className="avatar-img rounded-circle"
    //             src={!item.logo ? "/images/profiledp.png" : `${S3_URL}/${item?.logo}`}
    //             alt="img"
    //             data-bs-toggle="modal"
    //             data-bs-target={`#${imageViewModalId}`}
    //             style={{ cursor: 'pointer' }}
    //             onClick={() => { setSelectedImg(!item.logo ? "/images/profiledp.png" : `${S3_URL}/${item?.logo}`) }}
    //           />
    //         </div>,
            country: item.countryName || "-",
city: item.cityName || "-",
    country_city: `${item.cityName || "-"} / ${item.countryName || "-"}`,


    title: item?.title ? capitalizeWords(item?.title) : "-",
    jobType: item.jobType ? capitalizeWords(item.jobType) : "-",
category: item?.categoryName ? capitalizeWords(item.categoryName) : "-",

    experience: item?.experience ? item?.experience : "-",
    education: item?.education ? item.education : "-",
    isOpen: item?.isOpen ? "Open" : "Close",
    package: item?.isDisclose ? item.package : "Disclose",
    action: 
      <div className="dropdown">
        <button
          className=" border-0 bg-white"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-three-dots-vertical"
            viewBox="0 0 16 16"
          >
            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
          </svg>
        </button>
        <ul
          className="dropdown-menu"
          style={{ zIndex: "1000" }}
        >
          <li className="dropdown-item" 
            onClick={() => { updateJobHandler(item) }}
            data-bs-toggle="modal"
            data-bs-target={`#${addOrUpdateJobModalId}`}
          >
            <div style={{ cursor: "pointer" }}
            >
              Edit
            </div>
          </li>
        </ul>
      </div>
  }))

  const handleChangeStatus = async () => {
    try {
      setLoader(true)
      await changePartnerEarningWithdrawRequestStatusApi(confirmStatus)
      getAllJobList(selectedPage, limit);
      document.getElementById('confirmationModal').click()
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something Went Wrong")
      setLoader(false)
    }
  }

  const handleCityChange = (city) => {
    searchFormik.setFieldValue('cityId', city)
  }

  const filterCites = async (countryId) => {
    try {
      const res = await cityByCountryApi("", countryId)
      if (res.status === 200) {
        let cityOption = res.data?.data?.map(ele => ({ label: ele.name, value: ele.id }))
        setCityOptions(cityOption);
      }

    } catch (error) {
      console.log(error)
    }
  };

  const filterCountry = async (inputValue) => {
    try {
      const res = await countryListApi(inputValue)
      if (res.status === 200) {
        let cityOption = res.data?.data?.map(ele => ({ label: ele.name, value: ele.id }))
        setCountryOptions(cityOption);
      }
    } catch (error) {
      console.log(error)
    }
  };

  const handleCountryChange = (country) => {
    console.log(country, 'this is count')
    setCityOptions([])
    searchFormik.setFieldValue('countryId', country);
    searchFormik.setFieldValue('cityId', null);
    filterCites(country.value)
  }

  const searchFormik = useFormik({
    initialValues: {
      countryId: adminDetail.role !== "superAdmin" && adminDetail.countryId ? { label: adminDetail.countryName, value: adminDetail.countryId } : null,
      cityId: null,
    },
  })

  const formik = useFormik({
    initialValues: jobInitialValue,
    onSubmit: async (values) => {
      console.log(values)
      try {
                    console.log("Formik Values Before Payload:", values); // ✅ Confirm object

        setSubmitLoader(true)

        const payload = {
          ...values,
          countryId: values.countryId?.value || null,
          cityId: values.cityId?.value || null
        };

        const res = await addOrUpdateJobApi(payload)
        if (res.status === 200 || res.status === 201) {
          toast.success(res.data.message)
          getAllJobList(selectedPage, limit)
          document.getElementById(addOrUpdateJobModalId).click()
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "Something Went Wrong")

      }
      setSubmitLoader(false)
    },
    validationSchema: jobValidationSchema
  })

  


  const aboutUsFormik = useFormik({
    initialValues: { aboutUs: "", aboutUsFooter: ""},
    onSubmit: async (values) => {

      try {
        setSubmitLoader(true)
        const res = await addOrUpdateAboutUsApi(values)
        if (res.status === 200 || res.status === 201) {
          toast.success(res.data.message)
          document.getElementById(addOrUpdateAboutUsModalId).click()
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "Something Went Wrong")
        
      }
      setSubmitLoader(false)
    },
  })

  const getAboutUs = async () => {
    try {
      const res =await getAboutUsApi();
      if(res.status === 200) {
        aboutUsFormik.setFieldValue("aboutUs", res.data?.data?.aboutUs)
        aboutUsFormik.setFieldValue("aboutUsFooter", res.data?.data?.aboutUsFooter)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(()=> {
    getAllJobList(selectedPage, limit);
  }, [searchFormik.values])

  useEffect(() => {
    
    getAboutUs()
    if (adminDetail?.countryId) {
      filterCites(adminDetail.countryId);
    }

    if (adminDetail?.role === "superAdmin") {
      filterCountry();
    }
  }, [adminDetail])

  const toggleTab = (tab) => {
    setActiveTab(tab);
    setSearchParams({ tab: tab });
  }


  return (

    <>
      <div className="main-content">
        <div className="container-fluid">
          <div className='d-flex justify-content-between'>
            {searchParams.get("tab") !== "appversion" && <ul className="nav nav-tabs">
              <li className="nav-item">
                <button
                  className={`nav-link ${(activeTab === 'career' || searchParams.get("tab") == null) ? 'active' : ''}`}
                  onClick={() => toggleTab('career')}
                >
                  Careers
                </button>
              </li>

              <li className="nav-item">
                <button
                  className={`nav-link ${searchParams.get("tab") === 'category' ? 'active' : ''}`}
                  onClick={() => toggleTab('category')}
                >
                  Category
                </button>
              </li>
            </ul>}
          </div>
          <div className="row">
            {/* <BreadCrumb /> */}
            <div className="main-content">
              {/* HEADER */}
              <div className="row">
                {(activeTab === 'career' || searchParams.get("tab") == null) && <>
                  <div className="card">
                    <div className="d-flex justify-content-between flex-wrap align-items-center mt-3 mt-lg-0 py-4">
                      <LimitPagination getData={getAllJobList} />
                      <div style={{ display: "-webkit-inline-box"}}>
                        <div className="d-flex gap-2 justify-content-end align-items-center">
                        <div className="col-md-4 mb-3">
                  <label htmlFor="countryId" className="form-label">Country</label>
                  <ReactSelect
                    inputId="countryId"
                    options={countryOptions}
                    value={searchFormik.values.countryId} // <-- use directly from Formik
                    onChange={handleCountryChange}
                    onBlur={searchFormik.handleBlur}
                    classNamePrefix="react-select"
                    className="react-select-container"
                    isDisabled={!(adminDetail?.role === "superAdmin")}
                    name="countryId"
                    noOptionsMessage={() => 'No Countries Available'}
                  />
            

                </div>

               
                <div className="col-md-4 mb-3">
                  <label htmlFor="cityId" className="form-label">City</label>
                  <ReactSelect
                    inputId="cityId"
                    options={cityOptions}
                    value={searchFormik.values.cityId}  
                    onChange={handleCityChange}
                    onBlur={searchFormik.handleBlur}
                    classNamePrefix="react-select"
                    className="react-select-container"
                    isDisabled={!searchFormik.values.countryId}
                    name="cityId"
                    noOptionsMessage={() => 'No Cities Available'}
                  />
                 
                </div>
                        <div>
                          <div>
                            <button
                              className="btn btn-primary"
                              onClick={() => { searchFormik.resetForm(); }}
                              disabled={!searchFormik?.values?.countryId}
                            >
                              Reset filter
                            </button>
                          </div>
                        </div>

                      </div>
                        <button
                          type="button"
                          className="btn btn-primary me-2"
                          data-bs-toggle="modal"
                          data-bs-target={`#${addOrUpdateAboutUsModalId}`}
                          onClick={formik.resetForm}
                        >
                          Add/Update About us
                        </button>
                     
                        <button
                          type="button"
                          className="btn btn-primary"
                          data-bs-toggle="modal"
                          data-bs-target={`#${addOrUpdateJobModalId}`}
                          onClick={formik.resetForm}
                        >
                          Add 
                        </button>
                      </div>
                    </div>
                    <CommonTable headers={headerData} data={RequestTableData} loading={loader} />
                  </div>

                   {/* {totalCount > limit ? (
        <div className="d-flex justify-content-center">
          <ReactPaginate
            nextLabel="Next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            pageCount={page}
            previousLabel="< Previous"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination"
            activeClassName={"active"}
            forcePage={selectedPage - 1}
          />
        </div>
      ) : (
        ""
      )} */}

                  <button
                    className="d-none"
                    id="confirmModalBtn"
                    data-bs-toggle="modal"
                    data-bs-target="#confirmationModal">
                    openmodal
                  </button>
                  <ConfirmationModal
                    handleConfirm={handleChangeStatus}
                    confirmStatus={confirmStatus}
                    message={"Are You Sure?"}
                  />

                  <AddOrUpdateJob formik={formik} loading={submitLoader} modalId={addOrUpdateJobModalId} countryOptions={countryOptions} />
                  <ImageViewModal imgUrl={selectedImg} modalId={imageViewModalId} />
                  <AddOrUpdateAboutUs modalId={addOrUpdateAboutUsModalId} loading={submitLoader} formik={aboutUsFormik} />
                </>
                
                }
                {activeTab === 'category' && <>
                  <JobCategory />
                </>}
              </div>
            </div>
          </div>
        </div>
      </div>

      
    </>

  )
}




export default Jobs